import type { DefaultResponseBody, ListResponseBody, Playlist, Song } from "@gerama/types";
import type { ApiClient } from "../client";

export function createCorePlaylistsApi(client: ApiClient) {
  return {
    list: (
      params: { page?: number; limit?: number; artistId?: number } = {},
      signal?: AbortSignal,
    ) =>
      client
        .request<ListResponseBody<Playlist>>("/playlists", { query: { ...params }, signal })
        .then((res) => res.data ?? { list: [], count: 0 }),

    detail: (id: number, signal?: AbortSignal) =>
      client
        .request<DefaultResponseBody<Playlist>>(`/playlists/${id}`, { signal })
        .then((res) => res.data as Playlist),

    songs: (id: number, params: { page?: number; limit?: number } = {}, signal?: AbortSignal) =>
      client
        .request<ListResponseBody<Song>>(`/playlists/${id}/songs`, { query: { ...params }, signal })
        .then((res) => res.data ?? { list: [], count: 0 }),
  };
}
